// extracted by mini-css-extract-plugin
module.exports = {"Container":"MergedPattern_Container__3_Rl_","Link":"MergedPattern_Link__1EKFC","ThisPattern":"MergedPattern_ThisPattern__1sV13"};